import React, { FunctionComponent } from 'react';
import { Button, Form, Message, Modal } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

export interface ApiError {
    error?: boolean;
    message?: string;
}

export interface ConfirmModalProps {
    showModal: boolean;
    error?: ApiError;
    onAbort: () => void;
    onSubmit: () => void;
    onClose: () => void;
}
export const ConfirmChangesModal: FunctionComponent<ConfirmModalProps> = ({
    showModal = false,
    error = undefined,
    onAbort,
    onSubmit,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={showModal}
            size={'small'}
            closeOnEscape={true}
            closeOnTriggerBlur={true}
            onClose={onClose}
            closeIcon>
            <Modal.Header>{t('publicationEditor.confirmDialog.headline')}</Modal.Header>
            <Modal.Content data-testid={'ConfirmChangesModal.content'}>
                <Form>
                    <p>{t('publicationEditor.confirmDialog.hint')}</p>
                    <Message
                        visible={error?.error === true}
                        error
                        header={t('publicationEditor.confirmDialog.error')}
                        content={error?.message}
                        data-testid={'ConfirmChangesModal.content.message.error'}
                    />
                    <Message
                        visible={error?.error === false}
                        success
                        header={t('publicationEditor.confirmDialog.success')}
                        data-testid={'ConfirmChangesModal.content.message.success'}
                    />
                    <Button onClick={onAbort} active={false} size={'big'}>
                        {t('publicationEditor.abort')}
                    </Button>
                    <Button onClick={onSubmit} active={false} size={'big'}>
                        {t('publicationEditor.save')}
                    </Button>
                </Form>
            </Modal.Content>
        </Modal>
    );
};
